import styled from 'styled-components'
import variables from './variables'
import { Container as AlertContainer } from '../components/Alert/styles'

export const Row = styled.div`
  width: 100%;

  @media ${variables.media.lg} {
    display: flex;
    flex-direction: row;
  }
`

export const ContentColumn = styled.div`
  @media ${variables.media.lg} {
    width: 50%;
    max-width: 700px;

    padding-left: 45px;
    padding-right: 50px;

    ${props => props.noPadding && `
      padding: 0;
    `}
  }

  @media ${variables.media.xl} {
    width: 40%;
  }
`

export const CodeColumn = styled.div`
  margin-top: 30px;
  flex: 1;
  /* This will magically prevent the item to overflow its flex parent */
  /* https://stackoverflow.com/questions/43809612/prevent-a-child-element-from-overflowing-its-parent-in-flexbox */
  min-width: 0;

  @media ${variables.media.lg} {
    margin-top: 0;
    background: #f6f6f6;
    border-left: 1px solid #eee;
    padding-left: 50px;
    padding-right: 25px;

    code {
      background-color: #eee;
    }

    pre {
      background-color: #fdfdfd;
    }

    pre > code {
      background: none;
    }

    p {
      color: #777;
    }

    ${props => props.noPadding && `
      padding: 0;
    `}

    ${AlertContainer} p {
      color: #888 !important;
    }
  }
`

export const DividerHeader = styled.header`
  margin-top: 80px;
  color: #aaa;
  padding-bottom: 4px;
  font-weight: 400;
  border-bottom: 1px solid #dcdcdc;
  margin-right: 5%;
  font-size: 0.75rem;
  letter-spacing: 0.04rem;
  text-transform: uppercase;
`

export const MinimalTable = styled.table`
  margin-top: 10px;
  margin-bottom: 6px;

  th {
    display: none;
  }

  tr {
    border-bottom: none;
  }

  td {
    vertical-align: top;
    padding-left: 15px;
    padding-right: 15px;
  }

  td:first-child {
    width: 120px;
    text-align: right;
  }
`

export const AlignItemsCenter = styled.div`
  display: flex;
  align-items: center;
`

export const TechnicalSubTitle = styled.p`
  font-size: 1rem;
  font-family: 'Source Code Pro', Courier, sans-serif;
  color: #aaa;
  font-weight: 400;
  margin-left: 2px;
  margin-top: -8px;
  margin-bottom: 2rem;
`
